/**
 * Reduce whatever a scanner read to the value that goes in the `:code` path
 * segment.
 *
 * The QR encodes a URL (`https://host/u/ABCD…`) rather than a bare code, so that
 * a phone's own camera app does something useful with it. Any in-app scanner
 * reads the same image, so it has to strip back to the code. Query and hash go
 * first, then the last non-empty path segment; a bare code has no slashes and
 * falls through unchanged.
 *
 * Shape validation (alphabet, length) is deliberately NOT repeated here. The
 * API's `parseProfileCode` already rejects a garbage scan with a 404, and it
 * lives in `apps/api`'s helpers where this app cannot import it — so a copy here
 * would be a second definition of "valid" free to drift from the one that
 * actually decides.
 *
 * Hoisted out of `RecipientSearchPicker` (VERA-304) on its second call site: the
 * profile code page scans too, and two copies of "what counts as a code" is the
 * duplication working-conventions §36 exists to stop.
 */
export const extractProfileCode = (raw: string): string => {
  const withoutQuery = (raw || '').trim().split(/[?#]/)[0]
  const segments = withoutQuery.split('/').filter(Boolean)
  return segments[segments.length - 1] ?? ''
}
